import axiosClient from '../axiosClient';
import type { ProjectResponse } from '@/store/projectStore';

export interface UserRoleResponse {
  roleId: string; // Guid som string
  roleName: string;
  isAdmin: boolean;
}

export interface UserDatabaseResponse {
  dbName: string;
  hasAdminRole: boolean; // Computed property fra backend
  roles: UserRoleResponse[]; // List<UserRoleResponse> fra backend, ikke string[]
  project?: ProjectResponse;
}

/**
 * Hent alle databaser/prosjekter brukeren har tilgang til
 */
export async function getUserDatabases (signal?: AbortSignal): Promise<UserDatabaseResponse[]> {
  const response = await axiosClient.get<UserDatabaseResponse[]>('user/databases', { signal });
  return response.data;
}

